import * as React from 'react';

import {useLoaderData, useNavigate} from 'react-router-dom';
import {useMessage} from '../context/MessageProvider';
import {useAuth} from '../context/AuthProvider';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import {useForm, FormProvider} from 'react-hook-form';
//import {FormProvider} from '../components/form/FormProvider';
import Form from '../components/form/Form';
import FormTextField from '../components/form/FormTextField';
import FormButton from '../components/form/FormButton';
import FormDropDown from '../components/form/FormDropDown';
import FormDatePicker from '../components/form/FormDatePicker';
import FormRadioGroup from '../components/form/FormRadioGroup';

import Header from "../components/Header";

import { getAnimal, newAnimal, saveAnimal } from '../models/animals';
import {sex, genus, knownEstimated} from "../models/categories";
import { listLocations } from '../models/locations';

import { useConnectivity } from '../context/ConnectivityProvider';

import {schema} from '../models/biologySchema';

// if you need to load data, you can use this template, note that the return value needs to be an object with named records in it.
export async function loader({params}) {
    console.log(params);

    const animal = (params.animalId) ? await getAnimal(params.animalId) : await newAnimal();

    const locations = await listLocations();
    return {animal, sex: await sex(), genus: await genus(), knownEstimated: await knownEstimated(), locations};
}


export default function AnimalFormPage({title = "EWP",...props}) {
    const {setSuccess, setError} = useMessage();
    const {facilityId} = useAuth();
    const navigate = useNavigate();
    const {isOnline} = useConnectivity();

    console.log("facilityId: ", facilityId);
    // used to read the loader data that is returned from the function above
    const {animal, sex, knownEstimated, locations} = useLoaderData();
    const locationList = locations.map((cur) => ({ value: cur.name, label: cur.name }));
    //console.log("Animal Record: ", animal, sex, genus);

    console.log("schema", schema);

    const [working, setWorking] = React.useState(false);

    // if you're going to do a form submission, this is your starting point for the submit behavior
    const onSubmit = async (data) => {
        console.log('onSubmit animal data', data);
        try {
            setWorking(true);
            const {id} = await saveAnimal(data,facilityId,isOnline);
            setSuccess("Animal Saved");
            navigate("/animals/"+ id);
        } catch (error) {
            setError(error);
        }
        finally {
            setWorking(false);
        }
    }

    const defaultValues = {...newAnimal(),...{phylum: '', classes: '', order: '', genus: '', species: ''}};
    const formProps = { defaultValues, values: {...animal} };
	const methods = useForm(formProps);

    const phylumValue = methods.watch('phylum');
    const classesValue = methods.watch('classes');
    const orderValue = methods.watch('order');
    const genusValue = methods.watch('genus');
    console.log("watched values", phylumValue, classesValue, orderValue, genusValue);


    const phylum = schema.map((cur)=>{
        return {value: cur.scientificName, label: cur.commonName + " (" + cur.scientificName + ")"};
    });

    const classesList = schema.filter((cur) => {
        return (cur.scientificName === phylumValue);
    }).map((cur)=>{
        return cur.class
    })?.[0] || [];

    console.log("classesList", classesList);

    const classes = classesList.map((cur)=>{
        return {value: cur.scientificName, label: cur.commonName + " (" + cur.scientificName + ")"};
    });

    const orderList = classesList.filter((cur) => {
        return (cur.scientificName === classesValue);
    }).map((cur)=>{
        return cur.order;
    })?.[0] || [];
    console.log("orderList", orderList);
    const order = orderList.map((cur)=>{
        return {value: cur.scientificName, label: cur.commonName + " (" + cur.scientificName + ")"};
    })

    const genusList = orderList.filter((cur)=>{
        return (cur.scientificName === orderValue);
    }).map((cur)=>{
        return cur.genus;
    })?.[0] || [];

    console.log("genusList", genusList);
    const genus = genusList.map((cur)=>{
        return {value: cur.scientificName, label: cur.commonName + " (" + cur.scientificName + ")"};
    });


    const speciesList = genusList.filter((cur)=>{
        return (cur.scientificName === genusValue);
    }).map((cur)=>{
        return cur.species;
    })?.[0] || [];

    const species = speciesList.map((cur)=>{
        return {value: cur.scientificName, label: cur.commonName + " (" + cur.scientificName + ")"};
    });

    // note you can play with the container maxwidth to spread out the window content appears in
            //<FormProvider onSubmit={onSubmit} defaultValues={animal} ></FormProvider>
    return (
        <Container component="main" maxWidth="sm">
            <Header label={title} />

            <FormProvider {...methods}>
                <Form onSubmit={methods.handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                        <Grid xs={12} sm={6}>
                            <FormTextField name="name" label="Animal Name" required />
                        </Grid>

                        <Grid xs={12} sm={6}>
                            <FormTextField name="studbook_number" label="ID Number" required />
                        </Grid>

                        <Grid xs={12} sm={6}>
                            <FormDropDown name="sex" label="Sex" list={sex} required />
                        </Grid>

                        <Grid xs={12} sm={6}>
                            <FormDropDown name="location" label="Location" list={locationList} />
                        </Grid>

                        <Grid xs={12}>
                            <FormDropDown name="phylum" label="Phylum" list={phylum} required />
                        </Grid>

                        <Grid xs={12}>
                            <FormDropDown name="classes" label="Class" list={classes} required />
                        </Grid>

                        <Grid xs={12}>
                            <FormDropDown name="order" label="Order" list={order} required />
                        </Grid>

                        <Grid xs={12}>
                            <FormDropDown name="genus" label="Genus" list={genus} required />
                        </Grid>

                        <Grid xs={12}>
                            <FormDropDown name="species" label="Species" list={species} required />
                        </Grid>

                        <Grid xs={12} sm={6}>
                            <FormDatePicker name="born_on" label="Date Born" required/>
                        </Grid>

                        <Grid xs={12} sm={6}>
                            <FormRadioGroup name="born_on_is_estimated" label="Date Born" list={knownEstimated} required/>
                        </Grid>


                        <Grid xs={12} sm={6}>
                            <FormDatePicker name="entered_captivity_on" label="Date Entered Captivity" required/>
                        </Grid>

                        <Grid xs={12} sm={6}>
                            <FormRadioGroup name="entered_captivity_on_is_estimated" label="Date Entered Captivity" list={knownEstimated} required/>
                        </Grid>

                        <Grid xs={12} sm={6}>
                            <FormDatePicker name="arrived_on" label="Date Arrived At Current Institution" required/>
                        </Grid>

                        <Grid xs={12} sm={6}>
                            <FormRadioGroup name="arrived_on_is_estimated" label="Date Arrived At Current Institution" list={knownEstimated} required/>
                        </Grid>


                        <Grid xs={12}>
                            <FormButton working={working}>Submit</FormButton>
                        </Grid>
                    </Grid>
                </Form>
            </FormProvider>



        </Container>
    );
}
